const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Company Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Certificates', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/learn/v3/certificates/:subresource', null, {
    userCertificates: {params: {subresource: ''}, method: 'GET', isArray: true}
  });

}]);